import { render } from "./WeekPickSummary.vue?vue&type=template&id=0687d3b5"
import script from "./WeekPickSummary.vue?vue&type=script&lang=ts"
export * from "./WeekPickSummary.vue?vue&type=script&lang=ts"
script.render = render

export default script